import React from "react";
import { showTicketDetailsAtom, ticketAtom } from "../store";
import { useAtom } from "jotai";
import { formatTicketDetails } from "../utils";

const TicketDetailsContent = () => {
  const [data] = useAtom(ticketAtom);
  const [show] = useAtom(showTicketDetailsAtom);

  const fieldValues  = formatTicketDetails(data)
  

  if (!show) return null;

  return (
    <div className="td-content-bx">
      {fieldValues?.map((item, idx)=>{
        const extra = item.label?.toLocaleLowerCase() == 'description' ? { maxWidth: '100%' } : {};
        return (
          item.value && 
            <div key={idx} className='td-sub-bx' style={extra}>
              <div>
                <h4>{item.label}</h4>
                {item.label?.toLocaleLowerCase() == 'description'? (<p style={{fontSize:12}} dangerouslySetInnerHTML={{ __html: item.value }}/>):<p>{item.value}</p>}
                
              </div>
            </div>
        )
      })}
      {!data && 'No task details'}
    </div>
  );
};

export default TicketDetailsContent;
